import React from "react";
import styled from "styled-components";
import { Layout } from "../components/layout/Layout";
import { Mail } from "lucide-react";
import { Button } from "../components/common/Button";

const ContactContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-4);
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: var(--spacing-4);
  color: var(--color-text-primary);
`;

const ContactCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: var(--spacing-4);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacing-3);
  margin-bottom: var(--spacing-6);
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(226, 182, 22, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
`;

const ContactInfo = styled.div`
  color: var(--color-text-secondary);
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  background: rgba(255, 255, 255, 0.05);
  padding: var(--spacing-4);
  border-radius: 8px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
`;

const Label = styled.label`
  color: var(--color-text-primary);
`;

const Input = styled.input`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: var(--spacing-2);
  color: var(--color-text-primary);
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: var(--color-primary);
  }
`;

const Textarea = styled.textarea`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: var(--spacing-2);
  color: var(--color-text-primary);
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: var(--color-primary);
  }
`;

const Contact = () => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
  };

  return (
    <Layout>
      <ContactContainer>
        <Title>Contactez-nous</Title>

        <ContactCard>
          <IconWrapper>
            <Mail size={24} />
          </IconWrapper>
          <h3>Email</h3>
          <ContactInfo>ytbrelaxmusic@gmail.com</ContactInfo>
        </ContactCard>

        <ContactForm onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Nom</Label>
            <Input type="text" required name="name" autoComplete="name" />
          </FormGroup>

          <FormGroup>
            <Label>Email</Label>
            <Input type="email" required name="email" autoComplete="email" />
          </FormGroup>

          <FormGroup>
            <Label>Sujet</Label>
            <Input type="text" required name="subject" autoComplete="off" />
          </FormGroup>

          <FormGroup>
            <Label>Message</Label>
            <Textarea required />
          </FormGroup>

          <Button type="submit">Envoyer</Button>
        </ContactForm>
      </ContactContainer>
    </Layout>
  );
};

export default Contact;
